module.exports = __webpack_public_path__ + "static/media/jsjot.d6ac8ad5.png";